import React, { useState } from "react";

export type TCtx = {
  sidebarIsOpen: boolean;
  setSidebarIsOpen: (arg: boolean) => void;
};

const defaultState = {
  sidebarIsOpen: false,
  setSidebarIsOpen: (arg) => {},
};

export const AppContext = React.createContext<TCtx>(defaultState);

export const AppProvider = ({ children }: any) => {
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
  return (
    <AppContext.Provider
      value={{
        sidebarIsOpen,
        setSidebarIsOpen,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
